import { mergeSxProps } from "@src/appV2/lib";

import { Button, type ButtonProps, type ButtonSize, type ButtonVariant } from "./Button";
import { Icon, type IconType } from "./Icon";

export interface IconButtonProps
  extends Omit<ButtonProps, "startIconType" | "endIconType" | "children"> {
  size?: ButtonSize;
  variant?: ButtonVariant;
  iconType: IconType;
}

/**
 * An icon-only button that reuses Button variants and sizes.
 * Small size is circular, medium/large are square.
 */
export function IconButton(props: IconButtonProps) {
  const { iconType, size = "medium", sx, ...restProps } = props;

  return (
    <Button
      {...restProps}
      size={size}
      sx={mergeSxProps(
        (theme) => ({
          minWidth: "unset",
          // Small size: circular button
          ...(size === "small" && {
            padding: theme.size?.button.small.paddingY,
            height: "auto",
            borderRadius: "50%",
            aspectRatio: "1",
          }),
          // Medium/large: square button
          ...(size === "medium" && {
            padding: theme.size?.button.medium.paddingY,
          }),
          ...(size === "large" && {
            padding: theme.size?.button.large.paddingY,
          }),
        }),
        sx
      )}
    >
      <Icon type={iconType} />
    </Button>
  );
}
